/*jshint esversion: 11 */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Table,
  Label,
  FormGroup,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  ListGroup,
  ListGroupItem
} from 'reactstrap';
import { connect } from 'react-redux';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import PageDataLoader from '../Utility/PageDataLoader';
import Paginator from '../Utility/Paginator';
import moment from 'moment';
import { validatePermissionKey } from '../../helpers/permission';
import {
  CREATE_WEEKLY_ACTION_RECORD_TEMPLATE,
  DELETE_WEEKLY_ACTION_RECORD_TEMPLATE,
  UPDATE_WEEKLY_ACTION_RECORD_TEMPLATE,
  VIEW_WEEKLY_ACTION_RECORD_TEMPLATE
} from '../Utility/PermissionKeys';
import { useHistory } from 'react-router-dom';
import { getOfferingList } from '../../api/offering';

import {
  getWeeklyActionRecordTemplateList,
  getWeeklyActionRecordTemplateDetails,
  updateWeeklyActionRecordTemplate,
  deleteWeeklyActionRecordTemplate
} from '../../api/weeklyActionRecordTemplate';
import CreateWeeklyActionRecordTemplate from './CreateWeeklyActionRecordTemplate';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const WeeklyActionRecordTemplate = ({ authUser }) => {
  const history = useHistory();

  const [breadcrumbItems] = useState([
    { title: 'Weekly Action Templates', link: '#' },
    { title: 'View List', link: '#' }
  ]);
  const [templateListLoading, setTemplateListLoading] = useState(true);
  const [templateList, setTemplateList] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageLimit: 10,
    totalEntries: 0,
    totalPages: 0
  });
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState(null);
  const [templateDetailsLoading, setTemplateDetailsLoading] = useState(false);
  const [fullOfferingList, setFullOfferingList] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async (current_page = 1, page_limit = 200) => {
      const response = await getOfferingList(current_page, page_limit);
      setFullOfferingList(response?.data);
    };

    fetchData(1, 200);
  }, []);
  const handlePagination = (page) => {
    fetchData(page, pagination.pageLimit);
  };

  const fetchData = async (page = 1, limit = 10) => {
    setTemplateListLoading(true);
    const response = await getWeeklyActionRecordTemplateList(page, limit);

    if (response) {
      setPagination({
        currentPage: response.metadata.page,
        pageLimit: response.metadata.limit,
        totalPages: response.metadata.total_pages,
        totalEntries: response.metadata.total_results
      });
      setTemplateList(response.data);
      setTemplateListLoading(false);
    }
  };

  const openCreateModal = () => {
    setCreateModalOpen(true);
  };

  const closeCreateModal = () => {
    setCreateModalOpen(false);
  };

  const openViewModal = async (templateId) => {
    setTemplateDetailsLoading(true);
    setViewModalOpen(true);

    const template = await getWeeklyActionRecordTemplateDetails(templateId);
    if (template) {
      setCurrentTemplate(template);
    }

    setTemplateDetailsLoading(false);
  };

  const closeViewModal = () => {
    setViewModalOpen(false);
    setCurrentTemplate(null);
  };

  const openUpdateModal = async (templateId) => {
    setTemplateDetailsLoading(true);
    setUpdateModalOpen(true);

    const template = await getWeeklyActionRecordTemplateDetails(templateId);
    if (template) {
      setCurrentTemplate(template);
    }

    setTemplateDetailsLoading(false);
  };

  const closeUpdateModal = () => {
    setUpdateModalOpen(false);
    setCurrentTemplate(null);
  };

  const openDeleteModal = (template) => {
    setCurrentTemplate(template);
    setDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalOpen(false);
    setCurrentTemplate(null);
  };

  const handleTemplateCreated = () => {
    closeCreateModal();
    fetchData();
  };

  const handleTemplateUpdated = () => {
    closeUpdateModal();
    fetchData();
  };

  const handleTemplateDeleted = async () => {
    if (currentTemplate) {
      await deleteWeeklyActionRecordTemplate(currentTemplate._id);
      closeDeleteModal();
      fetchData();
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Weekly Action Templates"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <Row className="mt-2">
                    <Col md="2">
                      <FormGroup>
                        <Col md="12">
                          <Label className="col-form-label">Show Entries</Label>
                          <select
                            className="form-control"
                            onChange={(e) => {
                              fetchData(1, e.target.value);
                              setPagination({
                                ...pagination,
                                pageLimit: e.target.value
                              });
                            }}
                            value={pagination.pageLimit}
                            disabled={templateListLoading}
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col className="d-flex justify-content-end align-items-center">
                      {validatePermissionKey(
                        authUser,
                        CREATE_WEEKLY_ACTION_RECORD_TEMPLATE
                      ) && (
                        <Button
                          size="sm"
                          color="success"
                          className=" waves-effect waves-light"
                          onClick={openCreateModal}
                        >
                          <i className="ri-add-line align-middle mr-2"></i>
                          Create Template
                        </Button>
                      )}
                    </Col>
                  </Row>
                  {templateListLoading ? (
                    <div className="text-center">
                      <PageDataLoader />
                    </div>
                  ) : (
                    <div className="table-rep-plugin">
                      <div
                        className="table-responsive mb-0"
                        data-pattern="priority-columns"
                      >
                        <Table
                          id="weekly-action-templates-table"
                          striped
                          bordered
                          responsive
                        >
                          <thead>
                            <tr>
                              <th>SL. No</th>
                              <th>Offering</th>
                              <th>Activities</th>
                              <th>Created At</th>
                              <th>Last Updated</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {templateList?.map((template, index) => (
                              <tr key={index}>
                                <th>{index + 1}</th>
                                <td>
                                  <Link to={`/offerings`}>{template.offering?.name || 'N/A'}</Link>
                                  </td>
                                <td>{template.information?.length || 0}</td>
                                <td>
                                  {moment(template.createdAt).format(
                                    'DD-MM-YYYY'
                                  )}
                                </td>
                                <td>
                                  {moment(template.updatedAt).format(
                                    'DD-MM-YYYY'
                                  )}
                                </td>
                                <td>
                                  <Button
                                    size="sm"
                                    color="primary"
                                    className="mr-2 mb-2"
                                    onClick={() => openViewModal(template._id)}
                                  >
                                    <i className="fas fa-eye mr-2"></i>
                                    View
                                  </Button>
                                  {validatePermissionKey(
                                    authUser,
                                    UPDATE_WEEKLY_ACTION_RECORD_TEMPLATE
                                  ) && (
                                    <Button
                                      size="sm"
                                      color="warning"
                                      className="mr-2 mb-2"
                                      onClick={() =>
                                        openUpdateModal(template._id)
                                      }
                                    >
                                      <i className="fas fa-edit mr-2"></i>
                                      Edit
                                    </Button>
                                  )}
                                  {validatePermissionKey(
                                    authUser,
                                    DELETE_WEEKLY_ACTION_RECORD_TEMPLATE
                                  ) && (
                                    <Button
                                      size="sm"
                                      color="danger"
                                      className="mb-2"
                                      onClick={() => openDeleteModal(template)}
                                    >
                                      <i className="fas fa-trash mr-2"></i>
                                      Delete
                                    </Button>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  )}
                  <Row className="mt-2">
                    <Col md="5">
                      <p>
                        <strong>
                          Showing{' '}
                          {(pagination.currentPage - 1) * pagination.pageLimit +
                            1}{' '}
                          to{' '}
                          {Math.min(
                            pagination.currentPage * pagination.pageLimit,
                            pagination.totalEntries
                          )}{' '}
                          of {pagination.totalEntries} entries
                        </strong>
                      </p>
                    </Col>
                    {!templateListLoading && templateList.length > 0 && (
                      <Col md="7">
                        <Paginator
                          totalPages={pagination.totalPages}
                          currentPage={pagination.currentPage}
                          changePage={handlePagination}
                        />
                      </Col>
                    )}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Modals */}
        <CreateWeeklyActionRecordTemplate
          modalOpenState={createModalOpen}
          offeringList={fullOfferingList}
          closeModalHandler={closeCreateModal}
          onTemplateCreated={handleTemplateCreated}
          authUser={authUser}
        />

        <ViewWeeklyActionRecordTemplateModal
          modalOpenState={viewModalOpen}
          closeModalHandler={closeViewModal}
          template={currentTemplate}
          loading={templateDetailsLoading}
        />

        <UpdateWeeklyActionRecordTemplateModal
          modalOpenState={updateModalOpen}
          closeModalHandler={closeUpdateModal}
          template={currentTemplate}
          loading={templateDetailsLoading}
          onTemplateUpdated={handleTemplateUpdated}
        />

        <DeleteWeeklyActionRecordTemplateModal
          modalOpenState={deleteModalOpen}
          closeModalHandler={closeDeleteModal}
          template={currentTemplate}
          onDeleteConfirmed={handleTemplateDeleted}
        />
      </div>
    </React.Fragment>
  );
};

// View Modal Component
const ViewWeeklyActionRecordTemplateModal = ({
  modalOpenState,
  closeModalHandler,
  template,
  loading
}) => {
  return (
    <Modal isOpen={modalOpenState} size="lg">
      <ModalHeader toggle={closeModalHandler}>Template Details</ModalHeader>
      <ModalBody>
        {loading ? (
          <div className="text-center">
            <PageDataLoader />
          </div>
        ) : template ? (
          <div>
            <Row className="mb-3">
              <Col md="6">
                <Label className="font-weight-bold">Offering:</Label>
                <p>{template.offering_id?.name || 'N/A'}</p>
              </Col>
              <Col md="6">
                <Label className="font-weight-bold">Created At:</Label>
                <p>
                  {moment(template.createdAt).format('DD MMM YYYY, h:mm A')}
                </p>
              </Col>
            </Row>

            <Label className="font-weight-bold">Activities:</Label>
            <ListGroup>
              {template.information?.map((activity, index) => (
                <ListGroupItem
                  key={index}
                  className="d-flex justify-content-between align-items-center"
                >
                  <div>
                    <strong>{activity.activity}</strong>
                    <div className="mt-1">
                      <Badge
                        color={
                          activity.type === 'daily' ? 'primary' : 'success'
                        }
                      >
                        {activity.type}
                      </Badge>
                    </div>
                  </div>
                  <span className="badge badge-light badge-pill">
                    #{index + 1}
                  </span>
                </ListGroupItem>
              ))}
            </ListGroup>
          </div>
        ) : (
          <Alert color="warning">No template data available</Alert>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={closeModalHandler}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

// Update Modal Component
const UpdateWeeklyActionRecordTemplateModal = ({
  modalOpenState,
  closeModalHandler,
  template,
  loading,
  onTemplateUpdated
}) => {
  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  });
  const [successAlert, setSuccessAlert] = useState({
    show: false,
    message: ''
  });
  const [updating, setUpdating] = useState(false);
  const [informationList, setInformationList] = useState([]);

  useEffect(() => {
    if (template && template.information) {
      setInformationList([...template.information]);
    }
  }, [template]);

  const handleAddInformation = () => {
    setInformationList([...informationList, { activity: '', type: '' }]);
  };

  const handleRemoveInformation = (index) => {
    if (informationList.length <= 1) return;
    const newList = [...informationList];
    newList.splice(index, 1);
    setInformationList(newList);
  };

  const handleInformationChange = (index, field, value) => {
    const newList = [...informationList];
    newList[index][field] = value;
    setInformationList(newList);
  };

  async function handleTemplateUpdate(event) {
    event.preventDefault();
    setRequestError({ show_alert: false, message: '' });

    // Validation
    for (const [index, info] of informationList.entries()) {
      if (!info.activity.trim()) {
        setRequestError({
          show_alert: true,
          message: `Activity #${index + 1} is required`
        });
        return;
      }
      if (!info.type) {
        setRequestError({
          show_alert: true,
          message: `Please select a type for activity #${index + 1}`
        });
        return;
      }
    }

    const data = {
      information: informationList,
      offering_id: template.offering_id._id
    };

    setUpdating(true);
    const { response, error } = await updateWeeklyActionRecordTemplate(
      data,
      template._id
    );
    setUpdating(false);
    setSuccessAlert({ show: true, message: 'Template updated successfully' });

    if (error) {
      setRequestError({ show_alert: true, message: error });
      return;
    }

    if (onTemplateUpdated) {
      onTemplateUpdated();
    }
  }

  return (
    <Modal isOpen={modalOpenState} backdrop="static" size="lg">
      <ModalHeader toggle={closeModalHandler}>Update Template</ModalHeader>
      <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {loading ? (
          <div className="text-center">
            <PageDataLoader />
          </div>
        ) : template ? (
          <div>
            {requestError.show_alert && (
              <Alert
                color="danger"
                role="alert"
                isOpen={requestError.show_alert}
                toggle={() =>
                  setRequestError({ ...requestError, show_alert: false })
                }
              >
                <i className="mdi mdi-block-helper mr-2"></i>
                {requestError.message}
              </Alert>
            )}

            {successAlert.show && (
              <SweetAlert
                success
                title="Update"
                onConfirm={() => {
                  setSuccessAlert({ message: '', show: false });
                }}
              >
                {successAlert.message}
              </SweetAlert>
            )}

            <Row className="mb-3">
              <Col md="6">
                <Label className="font-weight-bold">Offering:</Label>
                <p>{template.offering_id?.name || 'N/A'}</p>
              </Col>
              <Col md="6">
                <Label className="font-weight-bold">Created At:</Label>
                <p>{moment(template.createdAt).format('DD MMM YYYY')}</p>
              </Col>
            </Row>

            <div className="d-flex justify-content-between align-items-center">
              <Label className="font-weight-bold">Activities:</Label>

              <Button
                color="primary"
                size="sm"
                className="mb-3"
                onClick={handleAddInformation}
              >
                <i className="ri-add-line align-middle mr-2"></i>
                Add Activity
              </Button>
            </div>

            {informationList.map((info, index) => (
              <div key={index} className="border p-3 mb-3">
                <Row>
                  <Col md="7">
                    <FormGroup>
                      <Label>Activity {index + 1}</Label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter activity description..."
                        value={info.activity}
                        onChange={(e) =>
                          handleInformationChange(
                            index,
                            'activity',
                            e.target.value
                          )
                        }
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label>Type</Label>
                      <select
                        className="form-control"
                        value={info.type}
                        onChange={(e) =>
                          handleInformationChange(index, 'type', e.target.value)
                        }
                        required
                      >
                        <option value="">Select Type</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                      </select>
                    </FormGroup>
                  </Col>
                  <Col
                    md="1"
                    className="d-flex justify-content-center align-items-center"
                  >
                    {informationList.length > 1 && (
                      <div className="text-right mt-2">
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => handleRemoveInformation(index)}
                        >
                          <i className="ri-delete-bin-line align-middle mr-1"></i>
                        </Button>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            ))}

            <ModalFooter>
              <Button
                disabled={updating}
                type="button"
                color="light"
                onClick={closeModalHandler}
              >
                Cancel
              </Button>
              <Button
                type="button"
                color="success"
                disabled={updating}
                onClick={handleTemplateUpdate}
              >
                {updating ? 'Updating...' : 'Update Template'}
              </Button>
            </ModalFooter>
          </div>
        ) : (
          <Alert color="danger">Failed to load template data</Alert>
        )}
      </ModalBody>
    </Modal>
  );
};

// Delete Modal Component
const DeleteWeeklyActionRecordTemplateModal = ({
  modalOpenState,
  closeModalHandler,
  template,
  onDeleteConfirmed
}) => {
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteError, setDeleteError] = useState('');

  useEffect(() => {
    // clear error when modal visibility changes
    setDeleteError('');
  }, [modalOpenState]);

  const handleDelete = async () => {
    if (!template) return;

    setDeleteLoading(true);
    setDeleteError('');

    try {
      await onDeleteConfirmed();
      closeModalHandler();
    } catch (error) {
      setDeleteError(error.message || 'Failed to delete template');
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <Modal isOpen={modalOpenState} backdrop="static" size="md">
      <ModalHeader toggle={closeModalHandler}></ModalHeader>
      <ModalBody>
        {deleteError && (
          <Alert color="danger" className="mb-3">
            {deleteError}
          </Alert>
        )}
        <h4>
          {`Are you sure you want to delete this template${
            template?.offering?.name ? ` (${template.offering.name})` : ''
          }?`}
        </h4>
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={deleteLoading}
          type="button"
          color="light"
          onClick={closeModalHandler}
        >
          Close
        </Button>
        <Button
          type="button"
          color="danger"
          disabled={deleteLoading}
          onClick={handleDelete}
        >
          {deleteLoading ? 'Deleting...' : 'Delete'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(WeeklyActionRecordTemplate);
